import { StatusDot } from "./StatusDot";

export function DashboardHeader({ connection, mode, setMode }) {
  return (
    <header className="topbar" data-testid="dashboard-header">
      <div>
        <p className="label" data-testid="dashboard-eyebrow">PERSONAL OKX SPOT CONTROL</p>
        <h1 data-testid="dashboard-title">Passive Spot Console</h1>
      </div>
      <div className="header-actions">
        <div className="connection" data-testid="okx-connection-status">
          <StatusDot active={connection.connected} />
          <span>{connection.connected ? "OKX KEY READY" : "PAPER MODE"}</span>
        </div>
        <div className="mode-toggle" data-testid="trading-mode-toggle">
          <button data-testid="paper-mode-button" className={mode === "paper" ? "active" : ""} onClick={() => setMode("paper")}>Paper</button>
          <button data-testid="live-mode-button" className={mode === "live" ? "danger active" : "danger"} onClick={() => setMode("live")}>Live</button>
        </div>
      </div>
    </header>
  );
}